import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { DragNDropDirective } from 'libs/portal/src/directives/drag-n-drop.directive';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { DataModule } from '../keepalive/components/data/data.module';
import { CardTableModule } from './card-table/card-table.module';
import { ChatPopupComponent } from './chat-popup/chat-popup.component';
import { DateTimeComponent } from './date-time/date-time.component';
import { DeviceAvailabilityGraphComponent } from './device-availability-graph/device-availability-graph.component';
import { DeviceBundleUsedChartComponent } from './device-bundle-used-chart/device-bundle-used-chart.component';
import { DeviceDetailsCardComponent } from './device-details-card/device-details-card.component';
import { DeviceDetailsRowCardComponent } from './device-details-row-card/device-details-row-card.component';
import { DeviceDetailsComponent } from './device-details/device-details.component';
import { DeviceEditModalComponent } from './device-edit-modal/device-edit-modal.component';
import { DeviceFullDetailComponent } from './device-full-detail/device-full-detail.component';
import { DeviceJitterGraphComponent } from './device-jitter-graph/device-jitter-graph.component';
import { DeviceLatencyGraphComponent } from './device-latency-graph/device-latency-graph.component';
import { DeviceMapComponent } from './device-map/device-map.component';
import { DeviceRingFenceLogComponent } from './device-ring-fence-log/device-ring-fence-log.component';
import { DeviceSimInfoComponent } from './device-sim-info/device-sim-info.component';
import { DeviceStatusOverTimeChartComponent } from './device-status-over-time-chart/device-status-over-time-chart.component';
import { ExportModalComponent } from './export-modal/export-modal.component';
import { FileImportModalComponent } from './file-import-modal/file-import-modal.component';
import { FiltersModule } from './filters/filters.module';
import { GenericGraphHandlerComponent } from './generic-graph-handler/generic-graph-handler.component';
import { GenericGraphComponent } from './generic-graph/generic-graph.component';
// import { LocationMapComponent } from "./location-map/location-map.component";
import { LocationPickerComponent } from './location-picker/location-picker.component';
import { ProgressTileComponent } from './progress-tile/progress-tile.component';
import { SearchableComboboxModule } from './searchable-combobox/searchable-combobox.module';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { TabbedNavListComponent } from './tabbed-nav-list/tabbed-nav-list.component';
import { TimeFrameSelectorComponent } from './time-frame-selector/time-frame-selector.component';
import { GroupServersModalComponent } from './group-servers-modal/group-servers-modal.component';
import { GraphModalComponent } from './graph-modal/graph-modal.component';
import { ShowConfigModalComponent } from './show-config-modal/show-config-modal.component';
import { ConfirmReasonModalComponent } from './confrim-reason-modal/confirm-reason-modal.component';
import { ApnPipePipe } from './pipes/apn-pipe.pipe';
import { InlineRefreshComponent } from './inline-refresh/inline-refresh.component';
import { TimeAgoExtendsPipe } from './pipes/time-ago.pipe';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatColComponent } from './mat-col/mat-col.component';
import { MatRowComponent } from "./mat-row/mat-row.component";
import { NumbersOnlyDirective } from '../../directives/numbers-only.directive';
import { DeviceCapModalComponent } from './device-cap-modal/device-cap-modal.component';
import { BaseMapComponent } from '@huge-monorepo/shared/components';
import { CollapsedMenuComponent } from './side-menu';

@NgModule({
    declarations: [
        SideMenuComponent,
        DeviceDetailsComponent,
        LocationPickerComponent,
        TabbedNavListComponent,
        DeviceDetailsRowCardComponent,
        DeviceDetailsCardComponent,
        DeviceRingFenceLogComponent,
        DeviceBundleUsedChartComponent,
        DeviceStatusOverTimeChartComponent,
        DeviceSimInfoComponent,
        // LocationMapComponent,
        // TimeAgoExtendsPipe,
        DeviceMapComponent,
        ChatPopupComponent,
        DeviceFullDetailComponent,
        DeviceAvailabilityGraphComponent,
        DeviceJitterGraphComponent,
        DeviceLatencyGraphComponent,
        DateTimeComponent,
        ProgressTileComponent,
        GenericGraphComponent,
        GenericGraphHandlerComponent,
        TimeFrameSelectorComponent,
        DeviceEditModalComponent,
        ExportModalComponent,
        FileImportModalComponent,
        DragNDropDirective,
        GroupServersModalComponent,
        GraphModalComponent,
        ShowConfigModalComponent,
        ConfirmReasonModalComponent,
        ApnPipePipe,
        InlineRefreshComponent,
        NumbersOnlyDirective,
        DeviceCapModalComponent,
        CollapsedMenuComponent,
    ],
    providers: [TimeAgoExtendsPipe],
    exports: [
        SideMenuComponent,
        DeviceDetailsComponent,
        LocationPickerComponent,
        TabbedNavListComponent,
        DeviceDetailsRowCardComponent,
        DeviceDetailsCardComponent,
        DeviceRingFenceLogComponent,
        DeviceBundleUsedChartComponent,
        DeviceStatusOverTimeChartComponent,
        DeviceSimInfoComponent,
        // LocationMapComponent,
        // TimeAgoExtendsPipe,
        DeviceMapComponent,
        CardTableModule,
        ChatPopupComponent,
        DeviceFullDetailComponent,
        DeviceAvailabilityGraphComponent,
        DeviceJitterGraphComponent,
        DeviceLatencyGraphComponent,
        DateTimeComponent,
        ProgressTileComponent,
        GenericGraphComponent,
        GenericGraphHandlerComponent,
        TimeFrameSelectorComponent,
        ExportModalComponent,
        FileImportModalComponent,
        DragNDropDirective,
        ConfirmReasonModalComponent,
        ApnPipePipe,
        InlineRefreshComponent,
        NumbersOnlyDirective,
        DeviceCapModalComponent,
        CollapsedMenuComponent,
    ],
    imports: [CommonModule, MaterialModule, NgApexchartsModule, FiltersModule, CardTableModule, SearchableComboboxModule, NgxMaterialTimepickerModule, DataModule, MatColComponent, MatRowComponent, BaseMapComponent]
})
export class ToolsModule {}
